import styled from "styled-components";

export const Collect = styled.div`
width: 60%;
margin: 30px auto;
text-align: start;
padding: 0 0 3rem 0;

@media (max-width: 768px) {
  width: 100%;
}
`